import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, reactive } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FastBidVariantsToggle',
  props: {
    target: {},
    wrapperClass: { default: "" }
  },
  setup(__props: any) {

  const props = __props;

  const state = reactive({
    isShow: false
  });

  const toggleShow = () => {
    state.isShow = !state.isShow;
    const elements = document.querySelectorAll<HTMLElement>(props.target);

    if (elements) {
      elements.forEach((element) => {
        if (state.isShow) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
    }

    if (props.wrapperClass) {
      const wrapperNode = document.querySelector<HTMLElement>(props.wrapperClass);

      if (wrapperNode) {
        if (state.isShow) {
          wrapperNode.classList.add("show-fast-bid-buttons");
        } else {
          wrapperNode.classList.remove("show-fast-bid-buttons");
        }
      }
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: toggleShow,
      class: _normalizeClass(["fast-bids-toggle-show", { active: state.isShow }])
    }, null, 2),
    _createElementVNode("div", {
      onClick: toggleShow,
      class: _normalizeClass(["fast-bids-toggle-show-mob", { active: state.isShow }])
    }, _toDisplayString(state.isShow ? "Hide buttons" : "More buttons"), 3)
  ], 64))
}
}

})